import AddPathwayContainer from './add_pathway_container';

const AddPathway = AddPathwayContainer;
export default AddPathway;
